<template>
	<div>
		<div class="handle flex-center-cross">
			<div class="item flex-center" title="发送表情" @click.stop="handleType = 'emoji'"><i class="tf">&#xe64d;</i></div>
			<div class="item flex-center" title="发送图片" @click="uploadHandle"><i class="tf">&#xec7f;</i></div>

			<div v-if="handleType == 'emoji'" class="emoji">
				<div class="emoji-list flex-wrap" @click.stop>
					<div v-for="(item, i) in emoji" :key="i" class="emoji-item flex-center" @click="emojiHandle(item)">{{item}}</div>
				</div>
			</div>
		</div>
		<div class="input">
			<textarea v-model="message" ref="textarea" placeholder="请输入消息，按Enter键或点击发送按钮发送，按Shift + Enter键换行" @blur="inputHandle" @keydown="inputHandle"></textarea>
			<div class="flex-end-center">
				<button :disabled="!message.trim()" @click="sendHandle">发送</button>
			</div>
		</div>
	</div>
</template>

<script>
	import emoji from '@/assets/script/emoji.json'

	export default {
		data() {
			return {
				message: '',
				handleType: '',
				emoji,

				targetStart: -1,
				targetEnd: -1
			}
		},

		mounted() {
			this._clearHandleType = () => {
				this.handleType = '';
			}
			window.addEventListener('click', this._clearHandleType);
		},

		beforeDestroy() {
			window.removeEventListener('click', this._clearHandleType);
		},

		methods: {
			reset() {
				this.message = '';
				this.targetStart = this.targetEnd = -1;
			},
			
			emojiHandle(item) {
				if (this.targetStart == -1) {
					this.message += item;
				} else {
					this.message = this.message.slice(0, this.targetStart) + item + this.message.slice(this.targetEnd);
					this.targetStart = this.targetEnd = this.targetStart + item.length;
				}
			},
			
			inputHandle(e) {
				if (e.key == 'Enter' && !e.shiftKey) {
					e.preventDefault();
					this.sendHandle();
				} else {
					this.targetStart = this.$refs.textarea.selectionStart;
					this.targetEnd = this.$refs.textarea.selectionEnd;
				}
			},

			sendHandle() {
				if (!this.message.trim()) {
					this.$message({
						message: '请输入消息内容'
					});
					return;
				}
				this.$emit('send', 'text', this.message);
			},
			
			uploadHandle() {
				this.$upload({
					type: 'image',
					success: ([data]) => {
						let img = new Image;
						img.src = data.path;
						img.onload = () => {
							this.$emit('send', 'image', data.path, JSON.stringify({
								width: img.width,
								height: img.height
							}));
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.handle {
		gap: 16px;
		position: relative;
		height: 50px;
		border-top: 1px solid #ccc;
		margin: 0 20px;

		.item {
			border-radius: 4px;
			width: 30px;
			height: 30px;
			font-size: 20px;
			color: #444;
			cursor: pointer;

			&:hover {
				color: #222;
				background: #ddd;
			}
		}
	}

	.input {
		textarea {
			box-sizing: border-box;
			width: 100%;
			height: 120px;
			border: none;
			padding: 0 20px 10px;
			line-height: 22px;
			font-size: 14px;
			background: none;
			resize: none;

			&::placeholder {
				color: #aaa;
			}
		}

		button {
			width: 74px;
			height: 36px;
			border: none;
			border-radius: 6px;
			margin: 12px 20px;
			font-size: 16px;
			color: #fff;
			background: #0284FF;

			&:not(:disabled):hover {
				opacity: .9;
			}

			&:disabled {
				color: #999;
				background: #E5E5E5;
				cursor: not-allowed;
			}
		}
	}

	.emoji {
		gap: 5px;
		position: absolute;
		left: 0;
		bottom: 100%;

		&:after {
			content: '';
			position: absolute;
			left: 9px;
			bottom: -6px;
			border-top: 6px solid #fff;
			border-left: 6px solid rgba(0,0,0,0);
			border-right: 6px solid rgba(0,0,0,0);
		}

		&-list {
			width: 415px;
			height: 200px;
			padding: 10px;
			overflow: auto;
			background: #fff;
			box-shadow: 0 0 10px 4px rgba(0,0,0,.05);
		}

		&-item {
			width: 40px;
			height: 40px;
			border-radius: 4px;
			font-size: 20px;
			cursor: pointer;
			user-select: none;

			&:hover {
				color: #222;
				background: #eee;
			}
		}
	}
</style>
